export default "__VITE_ASSET__D0uwbUY9__"